import { useState } from "react";
import { Globe, Instagram, Facebook, Linkedin, Youtube, Building2, MapPin } from "lucide-react";
import { Input } from "./ui/input";

const FIELDS = [
  ["businessName", "Business name", Building2, true],
  ["city", "City", MapPin, true],
  ["website", "Website URL", Globe, true],
  ["instagram", "Instagram link", Instagram],
  ["facebook", "Facebook link", Facebook],
  ["linkedin", "LinkedIn link", Linkedin],
  ["youtube", "YouTube link", Youtube],
];

export const BrandForm = ({ onSubmit, children, testPrefix = "onboarding", className = "" }) => {
  const [f, setF] = useState({});
  return (
    <form data-testid={`${testPrefix}-form`} onSubmit={(e) => { e.preventDefault(); onSubmit(f); }} className={`grid sm:grid-cols-2 gap-4 ${className}`}>
      {FIELDS.map(([k, label, Icon, req]) => (
        <label key={k} className={`space-y-1.5 ${k === "website" ? "sm:col-span-2" : ""}`}>
          <span className="text-xs text-slate-400 flex items-center gap-1.5"><Icon size={13} /> {label} {req && <span className="text-orange-500">*</span>}</span>
          <Input data-testid={`${testPrefix}-${k}-input`} required={req} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={k === "website" ? "https://yourbrand.com" : label} />
        </label>
      ))}
      <div className="sm:col-span-2 flex flex-wrap items-center justify-end gap-3 pt-2">{children}</div>
    </form>
  );
};
